module.exports = __webpack_public_path__ + "files/c7dcce084c445260a266f92db56f5517.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-italic.ttf
// module id = 1356
// module chunks = 59